import { Adslot } from '../modules/adslot-controller/adslot.js';
import { EffectFunction } from './index.js';

const sdgHideLabel = 'sdgHideLabel';
/**
 * Temporary removal of AdLabel, for example when some creatives bring their own adLabel.
 * Removal ist triggered via SlotAPI.toggleAdLabel(false) and should only apply for this exact ad impression.
 * On reload the effect should be removed.
 * @constructor
 */
export const HIDE_AD_LABEL: EffectFunction = ({ advertLabel }: Adslot) => {
    advertLabel.classList.add(sdgHideLabel);

    return () => {
        advertLabel.classList.remove(sdgHideLabel);
    };
};
